import React from 'react';
import styles from './EditableField.module.css';

interface EditableFieldProps {
  value: any;
  onEdit: () => void;
  isEditing: boolean;
  isLoading: boolean;
  error?: string;
  renderDisplay: (value: any) => React.ReactNode;
  renderEdit?: (value: any) => React.ReactNode;
  containerClassName?: string;
  isVisible?: boolean;
}

const EditableField: React.FC<EditableFieldProps> = ({
  value,
  onEdit,
  isEditing,
  isLoading,
  error,
  renderDisplay,
  renderEdit,
  containerClassName = '',
  isVisible = true
}) => {
  return (
    <div className={`${styles.container} ${containerClassName}`}>
      {renderDisplay(value)}
      {isVisible && (
        <button 
          className={styles.editButton}
          onClick={onEdit}
          disabled={isLoading}
        >
          <span className={styles.editIconSymbol}>✎</span>
        </button>
      )}
    </div>
  );
};

export default EditableField; 